export const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '';

export const MAP_DEFAULT_ZOOM = 13;

export const MAP_ID = 'ae6789a7d6fa641225666373';

export const MAP_LIBRARIES = ['places'];
